import React from 'react';
import Logo from '../images/suiteCartLogo.png';
import style from './index.module.scss';

import Facebook from '../images/FacebookLogo.png';
import Twitter from '../images/TwitterLogo.png';

const IndexPage = () => (
  <div className={style.index}>
    <div className={style.main}>
      <div className={style.header}>Coming Soon</div>
      <div className={style.top}>
        <div className={style.logo}>
          <img src={Logo} alt="Suite Cart Logo" />
        </div>
        <div className={style.content}>
          <div className={style.name}>Suite Carts</div>
          <div className={style.slogan}>The worlds suite-est carts</div>
        </div>
      </div>
      <div className={style.bottom}>
        <div className={style.message}>
          <h4>The next generation of data center carts</h4>
        </div>
        <div className={style.deals}>hello@suitecarts.com</div>
        <div className={style.social}>
          <a href="https://twitter.com/SuiteCarts">
            <img
              className={style.socialLogo}
              src={Twitter}
              alt="Twitter Logo"
            />
          </a>
          <a href="https://www.facebook.com/SuiteCarts">
            <img
              className={style.socialLogo}
              src={Facebook}
              alt="Facebook Logo"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.jsx